export const cities = [
  '1ro.de Marzo',
  '25 de Diciembre',
  '3 de Febrero',
  'Abaí',
  'Acahay',
  'Acaray mi',
  'Adamantina',
  'Aguaray Seco',
  'Alberdi',
  'Altamira',
  'Alto Piquirí',
  'Alto Verá',
  'Altos',
  'Ancash',
  'Anchieta',
  'Antequera',
  'Antidia Matiuda',
  'Anzoátegui',
  'Apucarana',
  'Araucária',
  'Areguá',
  'Arroyioto',
  'Arroyo Porá',
  'Arroyos y Esteros',
  'Assis Chateaubriand',
  'Asunción',
  'Atibaia',
  'Atyrá',
  'Avellaneda',
  'Ayolas',
  'Bagé',
  'Barcelona',
  'Barquisimeto',
  'Bejuma',
  'Belén',
  'Bella Vista',
  'Belo Horizonte',
  'Benjamín Aceval',
  'Beterete - Cue',
  'Bolivar',
  'Borja',
  'Bragança Paulista',
  'Bucaramanga',
  'Buena Vista',
  'Buenos Aires',
  'Butiá',
  'Caacupé',
  'Caaguazú',
  'Caapucú',
  'Caarapó',
  'Caazapá',
  'Calçado',
  'Calera Guyrati',
  'Cambyretá',
  'Cambyretá',
  'Campo Ere',
  'Campo grande',
  'Campo Mourao',
  'Campos Novos',
  'Canasvieras',
  'Capiatá',
  'Capiibary',
  'Capitán Bado',
  'Capitán Meza',
  'Capitán Miranda',
  'Caracas',
  'Caraguatay',
  'Carapeguá',
  'Carayaó',
  'Carlos Antonio López',
  'Carmen del Paraná',
  'Cascavel',
  'Cazorla',
  'Cecilio Báez',
  'Cedrales',
  'Cerrito',
  'Cerro Largo',
  'Cerro León',
  'Cerro Syryca',
  'Cerro Torín',
  'Céu Azul',
  'Chaco',
  'Chiriguelo',
  'Chore',
  'Ciudad de Guatemala',
  'Ciudad del Este',
  'Clevelândia',
  'Col. Sgto. José F. López ',
  'Colonia Alborada',
  'Colonia Ape Aime',
  'Colonia Aquidaban Cañada',
  'Colonia Arapoti',
  'Colonia Arroyo Moroti',
  'Colonia Carlos Pfannl',
  'Colonia Chacore',
  'Colonia Cleto Romero ',
  'Colonia Curupayty',
  'Colonia Domingo Montanaro',
  'Colonia Dr. Blás Garay',
  'Colonia Dr. Francia',
  'Colonia El Triunfo',
  'Colonia Excombatiente',
  'Colonia Federico Chávez',
  'Colonia Gral. Bruguez',
  'Colonia Herminio Mendoza',
  'Colonia Itaipu Pora',
  'Colonia J. E. Estigarríbia',
  'Colonia Jorge Sebastián Mirand',
  'Colonia Juan Sinforiano Bogarí',
  'Colonia Kiray',
  'Colonia Laura',
  'Colonia Lomas Valentina',
  'Colonia Luz Bella',
  'Colonia Maracamoa',
  'Colonia Maracamoa',
  'Colonia Marangatú',
  'Colonia Mbarete',
  'Colonia Naranjito',
  'Colonia Padre Guido Coronel',
  'Colonia Paraná',
  'Colonia Pfannl ',
  'Colonia Piki',
  'Colonia Pysyry',
  'Colonia Raúl Peña',
  'Colonia San Francisco',
  'Colonia San Ramón',
  'Colonia Santo Domingo',
  'Colonia Toryvete',
  'Colonia Vice Presidente Sánche',
  'Colonia Walter Insfrán',
  'Colonia Yguazú',
  'Colonia Yuquyty',
  'Concepción',
  'Coronel Bogado',
  'Coronel Martínez',
  'Coronel Oviedo',
  'Corpus Christi',
  'Criciúma',
  'Crissiumal',
  'Cruz Alta',
  'Cruz das Almas',
  'Cúcuta',
  'Cumanacoa',
  'Curitiba',
  'Curuguaty',
  'Desmochados',
  'Domingo Martínez de Irala',
  'Dourados',
  'Dr. Bottrell',
  'Dr. Juan Eulogio Estigarribia',
  'Dr. Juan Manuel Frutos',
  'Dr. Juan Ramón Chávez',
  'Dr. Moisés Bertoni',
  'Dr. Pedro P.Peña',
  'Durazno',
  'Edelira',
  'Ejido',
  'El Dorado',
  'El Vigía',
  'Emboscada',
  'Encarnación',
  'Escobar',
  'Estribo de Plata',
  'Eusebio Ayala',
  'Felipe Matiauda',
  'Félix Pérez Cardozo',
  'Fernando de la Mora',
  'Filadelfia',
  'Formosa',
  'Fortuna Guazú',
  'Foz do Iguaçu',
  'Fram',
  'Francisco Beltrão',
  'Francisco Caballero Álvarez',
  'Fuerte Olimpio',
  'General Artigas',
  'General Bernardino Caballero',
  'General Delgado',
  'General Elizardo Aquino',
  'General Eugenio Alejandrino Ga',
  'General Higinio Morínigo',
  'General Isidoro Resquín',
  'General José Eduvigis Díaz',
  'Goiânea',
  'Gral. Francisco C. Álvarez',
  'Grão Mogol',
  'Guaporé',
  'Guarambaré',
  'Guaraniaçú',
  'Guarulhos',
  'Guayaybí',
  'Guazúcuá',
  'Hernandarias',
  'Hohenau',
  'Horizontina',
  'Horqueta',
  'Humaitá',
  'Ibiara',
  'Ibirapitanga',
  'Ijuí',
  'Ilegible',
  'Independencia',
  'Iporã',
  'Iquique',
  'Iruña',
  'Isidro Casa Nova',
  'Isla Apipe Grande',
  'Isla Pucú',
  'Isla Talavera',
  'Isla Umbú',
  'Isla Yacyretá',
  'Itá',
  'Itacurubí de las Cordilleras',
  'Itacurubí del Rosario',
  'Itaituba',
  'Itakyry',
  'Itanará',
  'Itanhomi',
  'Itapé',
  'Itapua Poty',
  'Itauguá',
  'Iturbe',
  'Ivaipora',
  'J. Augusto Saldivar',
  'Jandaia do Sul',
  'Jesús y Trinidad',
  'Jhoannesburgo',
  'Jhugua Tadeo',
  'José Domingo Ocampos',
  'José Falcón',
  'José Fassardi',
  'José Leandro Oviedo',
  'Juan de Mena',
  'Juan Emilio O Leary',
  'Juan León Mallorquín',
  'Juazeiro',
  'Julián Augusto Saldívar',
  'Katuete',
  'Koga',
  'La Colmena',
  'La Habana',
  'La Paloma ',
  'La Pastora',
  'La Paz',
  'La Victoria',
  'Lambaré',
  'Laranjeiras',
  'Laureles',
  'Liberación',
  'Lima',
  'Limpio',
  'Loma Grande',
  'Loma Plata',
  'Loma Pytá',
  'Londrina',
  'Loreto',
  'Los Cedrales',
  'Luque',
  'Maciel',
  'Mafussi',
  'Mairiporã',
  'Málaga',
  'Maracaibo ',
  'Maracay',
  'Marechal Candido Rondon',
  'Marechal Cândido Rondon',
  'María Auxiliadora',
  'Maria Helena',
  'Maria Helena',
  'Mariano Roque Alonso',
  'Marília',
  'Maringá',
  'Mariscal Francisco Solano Lópe',
  'Mariscal Francisco Solano Lópe',
  'Mariscal José Félix Estigarrib',
  'Marmeleiro',
  'Maturín',
  'Mauá',
  'Mauricio José Troche',
  'Mayor José Martínez',
  'Mayor Julio Otaño',
  'Mayor Pablo Lagerenza',
  'Mbaracayú',
  'Mbocayaty',
  'Mbocayaty del Yhaguy',
  'Mbuyapey',
  'Medianeira',
  'Memphis',
  'Mérida',
  'Minga Guazú',
  'Minga Porá',
  'Misiones',
  'Missal',
  'Mogi das Cruzes',
  'Montevideo',
  'Montiel Potrero',
  'Mumbai',
  'Mundo Novo',
  'Ñacunday',
  'Nanawa',
  'Naranjal',
  'Naranjito',
  'Natalicio Talavera',
  'Natalio',
  'Navirai',
  'Ñemby',
  'Neuland',
  'Nice',
  'No Especificado',
  'No informada',
  'Nova Aurora',
  'Nova Prata do Iguaçu',
  'Nueva Alborada',
  'Nueva Colombia',
  'Nueva Esperanza',
  'Nueva Fortuna',
  'Nueva Germania',
  'Nueva Italia',
  'Nueva Londres',
  'Ñumí',
  'Obligado',
  'Pacaembú',
  'Palmeira das Missoes',
  'Palmeira dos Índios',
  'Palmitinho',
  'Palotina',
  'Paraguarí',
  'Paraíso',
  'Paranavaí',
  'Paso Barreto',
  'Paso Curuzu',
  'Paso de Patria',
  'Paso Ita',
  'Paso Yobai',
  'Pato Branco',
  'Pedro Juan Caballero',
  'Picada Lorito',
  'Pilar',
  'Pindamonhangaba',
  'Pindó',
  'Piracicaba',
  'Pirapey',
  'Pirapó',
  'Pirayú',
  'Pirayúi',
  'Piribebuy',
  'Planalto',
  'Pongaí',
  'Ponta Grossa',
  'Ponta Porã',
  'Porlamar',
  'Porto Alegre',
  'Posadas',
  'Pozo Colorado',
  'Presidente Franco',
  'Presidente Prudente',
  'Presidente Stroessner',
  'Primeiro de Maio',
  'Puente Kyjha',
  'Puerto Calera Guyrati',
  'Puerto Casado',
  'Puerto de la cruz ',
  'Puerto Fonciere',
  'Puerto Guyrati',
  'Puerto Iguazú',
  'Puerto Índio',
  'Puerto Itaipyte',
  'Puerto Itaverá',
  'Puerto Lomas Valentinas',
  'Puerto López',
  'Puerto Ordaz',
  'Puerto Paranambú',
  'Puerto Pinasco',
  'Puerto Píritu',
  'Puerto Triunfo',
  'Puerto Ybapobó',
  'Punta Potrero',
  'Punto Fijo',
  'Quiindy',
  'Quilmes',
  'Quintero',
  'Quyquyhó',
  'R.I.3 Corrales',
  'Raúl Arsenio Oviedo',
  'Recife',
  'Repatriación',
  'Resistencia',
  'Rio de Janeiro',
  'Roque Gonzalez',
  'Rosario',
  'Rubim',
  'Salto del Guairá',
  'Salto do Lontra',
  'San Agustín',
  'San Alberto',
  'San Antonio',
  'San Bernardino',
  'San Carlos del apa',
  'San Cosme y Damián',
  'San Cristóbal',
  'San Cristóbal',
  'San Dionísio',
  'San Estanislao',
  'San Felipe',
  'San Felipe',
  'San Ignacio',
  'San Isidro del Norte',
  'San Joaquín',
  'San José de Guanipa',
  'San José de los Arroyos',
  'San José Obrero',
  'San Juan Bautista',
  'San Juan del Ñeembucú',
  'San Juan del Paraná',
  'San Juan Nepomuceno',
  'San Juan Potero',
  'San Justo',
  'San Lázaro',
  'San Lorenzo',
  'San Luis del Paraná',
  'San Miguel',
  'San Pablo - PY',
  'San Patricio',
  'San Pedro',
  'San Pedro de Ycuamandyyú',
  'San Pedro del Paraná',
  'San Rafael del Paraná',
  'San Ramón',
  'San Roque González',
  'San Salvador',
  'Santa Cecilia',
  'Santa Clara',
  'Santa Cruz de la Sierra',
  'Santa Elena',
  'Santa Fé de Bogotá',
  'Santa Fé del Paraná',
  'Santa Inês',
  'Santa Librada',
  'Santa María',
  'Santa María de Cariaco',
  'Santa Rita',
  'Santa Rosa',
  'Santa Rosa del Aguaray',
  'Santa Rosa del Mbutuy',
  'Santa Rosa del Monday',
  'Santa Terezinha do Itaipu',
  'Santiago',
  'Santiago de Cuba',
  'Santo Ângelo',
  'Santo Angelo',
  'Santo Antonio do Sudoeste',
  'Santo Cristo',
  'Santos',
  'São Bernardo do Campo',
  'São Carlos ',
  'São João da Boa Vista',
  'São Miguel do Oeste',
  'São Paulo - BR',
  'Sapucai',
  'Sargento Duré',
  'Simón Bolivar',
  'Sinop',
  'Sorocaba',
  'Suzano',
  'Taboão da Serra',
  'Tacuaras',
  'Tacuatí',
  'Taruma - Yhu',
  'Tavaí',
  'Tavapy',
  'Tebicuary',
  'Tebicuarymí',
  'Tel Aviv - Yafo',
  'Teniente Esteban Martínez',
  'Teresina',
  'Terra Roxa',
  'Terra Roxa',
  'Tobarra',
  'Tobatí',
  'Toledo',
  'Tomás Romero Pereira',
  'Três de Maio',
  'Trinidad',
  'Tucano',
  'Tupã',
  'Ubiratã',
  'Unión',
  'Upata',
  'Urupês',
  'Valencia',
  'Valenzuela',
  'Valle de la Pascua',
  'Vallemí',
  'Vaquería',
  'Villa del Rosario',
  'Villa Elisa',
  'Villa Florida',
  'Villa Franca',
  'Villa Hayes',
  'Villa Oliva',
  'Villa Pastoreo',
  'Villa Ygatymí',
  'Villalbín',
  'Villarrica',
  'Villeta',
  'Xaxim',
  'Yabebyry',
  'Yaguarón',
  'Yaracuy',
  'Yasy Cañy',
  'Yataity',
  'Yataity del Norte',
  'Yatytay',
  'Yby Yaú',
  'Ybycuí',
  'Ybyrarobana',
  'Ybyrarobana',
  'Ybytymí',
  'Ycua Pora',
  'Yegros',
  'Ygatymí',
  'Yhú',
  'Ypacaraí',
  'Ypané',
  'Ypehú',
  'Yrybucuá',
  'Ytaity del Norte',
  'Yukyry',
  'Yuty',
  'Zanja Pytá',
]
